<template>
  <div>
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="showDialog" width="1150px"
      @close="setDialogClosed" append-to-body>
      <el-container class="container" direction="vertical" style="height: 500px">
        <ul style="overflow: auto; margin-right: 20px">
          <el-descriptions :column="4" border style="margin-bottom: 10px">
            <el-descriptions-item span="2" label="随访">
              {{ detail.serviceName }}
            </el-descriptions-item>

            <el-descriptions-item span="2" label="姓名">
              {{ detail.patientName }}
            </el-descriptions-item>

            <el-descriptions-item span="2" label="电话">
              {{ detail.phone }}
            </el-descriptions-item>

            <el-descriptions-item span="2" label="身份证号">
              {{ detail.idcard }}
            </el-descriptions-item>

            <!-- <el-descriptions-item span="2" label="住址">
              {{ detail.address }}
            </el-descriptions-item> -->

            <!-- <el-descriptions-item span="2" label="联系人">
              {{ detail.contactName }}
            </el-descriptions-item>

            <el-descriptions-item span="2" label="联系人电话">
              {{ detail.contactPhone }}
            </el-descriptions-item> -->

            <el-descriptions-item span="4" label="*症状">
              <el-radio v-model="symptomRadio" label="1">无</el-radio>
              <el-radio v-model="symptomRadio" label="2">有</el-radio>
              <el-checkbox-group v-if="symptomVisiable" v-model="detail.content.symptoms" style="display: flex;">
                <el-checkbox v-for="item in symptomList" :label="item" :key="item">{{ item }}</el-checkbox>
              </el-checkbox-group>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="体征">
              <el-descriptions :column="4" border labelStyle="width: 160px">
                <el-descriptions-item span="2" label="空腹血糖值(mmol/L)">
                  {{ detail.content.emptyGlu }}
                </el-descriptions-item>

                <el-descriptions-item span="2" label="餐后血糖值(mmol/L)">
                  {{ detail.content.twohourGlu }}
                </el-descriptions-item>

                <el-descriptions-item span="2" label="随机血糖值(mmol/L)">
                  {{ detail.content.randomGlu }}
                </el-descriptions-item>

                <el-descriptions-item span="2" label="*身高(cm)">
                  <el-input v-model="detail.content.height"></el-input>
                </el-descriptions-item>

                <el-descriptions-item span="2" label="*血压(mmHg)">
                  <el-input style="width: 80px;" v-model="detail.content.sbp" placeholder="收缩压"></el-input>/<el-input
                    v-model="detail.content.dbp" style="width: 80px;" placeholder="舒张压"></el-input>
                </el-descriptions-item>

                <el-descriptions-item span="2" label="*体重(kg)">
                  <el-input v-model="detail.content.weight"></el-input>
                </el-descriptions-item>

                <el-descriptions-item span="2" label="*腰围(cm)">
                  <el-input v-model="detail.content.waist"></el-input>
                </el-descriptions-item>

                <el-descriptions-item span="2" label="足背动脉搏动">
                  <el-select v-model="detail.content.dorsalisPedisPulse" placeholder="请选择">
                    <el-option v-for="item in dorsalisPedisPulseOptions" :key="item.value" :label="item.label"
                      :value="item.value" style="width: 200px"></el-option>
                  </el-select>
                </el-descriptions-item>

              </el-descriptions>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="生活方式指导">
              <el-descriptions :column="3" border labelStyle="width: 160px">
                <el-descriptions-item label="*日吸烟量(支/天)">
                  <el-input v-model="detail.content.smokePerday"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="*日饮酒量(两)">
                  <el-input v-model="detail.content.drinkPerday"></el-input>
                </el-descriptions-item>

                <el-descriptions-item label="*日吸烟量指导(支/天)">
                  <el-input v-model="detail.content.smokePerdayTarget"></el-input>
                </el-descriptions-item>

                <el-descriptions-item span="3" label="日饮酒量指导">
                  <el-descriptions :colums="2" border>
                    <el-descriptions-item label="*饮酒品类">
                      <el-select style="width:80px" v-model="detail.content.drinkType" placeholder="请选择">
                        <el-option v-for="item in drinkTypeList" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>

                    <el-descriptions-item style="display: flex;" label="*饮酒量">
                      <el-input style="width:80px" v-model="detail.content.drinkPerdayTarget"></el-input>
                      <el-select style="width:80px" v-model="detail.content.drinkUnit" placeholder="请选择">
                        <el-option v-for="item in drinkUnitList" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>

                <el-descriptions-item :span="3" label="运动基本情况">
                  <el-descriptions :colums="4" border labelStyle="width: 230px">
                    <el-descriptions-item span="2" label="*运动频次(次/周)">
                      <el-input v-model="detail.content.sportFreq"></el-input>
                    </el-descriptions-item>

                    <el-descriptions-item span="2" label="*运动时长(分钟/次)">
                      <el-input v-model="detail.content.sportMinutesPertime"></el-input>
                    </el-descriptions-item>

                    <el-descriptions-item span="2" label="*运动时是否有胸闷、胸痛不适感">
                      <el-select v-model="detail.content.sportTired" placeholder="请选择">
                        <el-option v-for="item in sportTiredList" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>

                    <el-descriptions-item span="2" label="*运动过程中是否有过跌倒情况">
                      <el-select v-model="detail.content.sportFall" placeholder="请选择">
                        <el-option v-for="item in sportTiredList" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>

                    <el-descriptions-item span="2" label="*运动过程中是否有低血糖情况">
                      <el-select v-model="detail.content.sportBloodsugar" placeholder="请选择">
                        <el-option v-for="item in sportTiredList" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>

                    <el-descriptions-item span="2" label="*是否存在足底破溃">
                      <el-select v-model="detail.content.sportFoot" placeholder="请选择">
                        <el-option v-for="item in sportTiredList" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>

                <el-descriptions-item :span="3" label="运动行为指导">
                  <el-descriptions :colums="4" border>
                    <el-descriptions-item span="2" label="*运动形式">
                      <el-select v-model="detail.content.sportType" placeholder="请选择" @change="sportTypeSelectChange">
                        <el-option v-for=" item  in  sportTypeList" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>
                    <el-descriptions-item span="2" label="*运动时间">
                      <el-select multiple v-model="detail.content.sportPeriodGuides" placeholder="请选择" :disabled="sportTypeSelectDisable">
                        <el-option v-for="item in dosageList" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>
                    <el-descriptions-item span="2" label="*运动时长">
                      <el-select v-model="detail.content.sportMinutesPertimeTarget" placeholder="请选择" :disabled="sportTypeSelectDisable">
                        <el-option v-for="item in sportMinutesEachList" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>
                    <el-descriptions-item span="2" label="*运动频次">
                      <el-select v-model="detail.content.sportFreqTarget" placeholder="请选择" :disabled="sportTypeSelectDisable">
                        <el-option v-for="item in sportFreqList" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>

                <el-descriptions-item span="3" label="饮食习惯">
                  <el-descriptions :colums="4" border labelStyle="width: 230px">
                    <el-descriptions-item span="4" label="*您是否了解饮食与血糖的影响">
                      <el-select v-model="detail.content.knowDietSugar" placeholder="请选择">
                        <el-option v-for="item in sportTiredList" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>

                    <el-descriptions-item span="4" label="*您是否执行过糖尿病饮食">
                      <el-select v-model="detail.content.obeyDiabetesDiet" placeholder="请选择">
                        <el-option v-for="item in sportTiredList" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>

                    <el-descriptions-item span="4" label="*您的三餐是否有规律">
                      <el-select v-model="detail.content.dietRegular" placeholder="请选择">
                        <el-option v-for="item in sportTiredList" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>

                    <el-descriptions-item span="4" label="*您的口味偏好">
                      <el-select v-model="detail.content.taste" placeholder="请选择">
                        <el-option v-for="item in tasteList" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>

                    <el-descriptions-item span="4" label="*您的饮食嗜好">
                      <el-select v-model="detail.content.dietHobbies" placeholder="请选择">
                        <el-option v-for="item in dietHobbiesList" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>

                <el-descriptions-item span="3" label="*饮食指导">
                  <el-input v-model="detail.content.dietGuide" placeholder="请输入内容"></el-input>
                </el-descriptions-item>
              </el-descriptions>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="用药指导">
              <el-descriptions :column="4" border>
                <el-descriptions-item span="4" label="基本情况">
                  <el-descriptions :column="1" border labelStyle="width: 150px">
                    <el-descriptions-item label="*服药依从性">
                      <el-select v-model="detail.content.medicationAdherence" placeholder="请选择">
                        <el-option v-for="item in medicationAdherenceOptions" :key="item.value" :label="item.label"
                          :value="item.value" style="width: 200px">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>

                    <el-descriptions-item style="display: flex;" label="*药物不良反应">
                      <el-radio v-model="medicationBadEventRadio" label="1">无</el-radio>
                      <el-radio v-model="medicationBadEventRadio" label="2">有</el-radio>
                      <el-input style="width: 200px;" v-if="medicationBadEventVisiable"
                        v-model="detail.content.medicationBadEvent" placeholder="请输入内容"></el-input>
                    </el-descriptions-item>

                    <el-descriptions-item label="*是否有药物过敏史">
                      <el-select v-model="detail.content.allergy" placeholder="请选择">
                        <el-option v-for="item in sportTiredList" :key="item.value" :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>

                    <el-descriptions-item label="*低血糖反应">
                      <el-select v-model="detail.content.hypoglycemiaReaction" placeholder="请选择">
                        <el-option v-for="item in hypoglycemiaReactionOptions" :key="item.value" :label="item.label"
                          :value="item.value" style="width: 200px">
                        </el-option>
                      </el-select>
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>


                <el-descriptions-item span="4" label="目前用药情况">
                  <el-descriptions :column="1" border>
                    <el-descriptions-item class="medicines" label="用药" v-for="(item, index) in detail.content.medicines"
                      :key="index">
                      <el-descriptions :column="4" border>
                        <el-descriptions-item span="2" label="药物名称">
                          <el-autocomplete class="inline-input" v-model="item.medicineName" :fetch-suggestions="querySearchAsync"
                          placeholder="请输入内容" :trigger-on-focus="false"></el-autocomplete>
                        </el-descriptions-item>
                        <el-descriptions-item span="2" label="用药次数/日">
                          <el-input v-model="item.freq"></el-input>
                        </el-descriptions-item>
                        <el-descriptions-item span="2" label="用量/次">
                          <el-input v-model="item.dosage"></el-input>
                        </el-descriptions-item>
                        <el-descriptions-item span="2" label="用药时间">
                          <el-input v-model="item.takeMethod"></el-input>
                        </el-descriptions-item>
                        <el-descriptions-item span="4" label="注意事项">
                          <el-input type="textarea" v-model="item.remark"></el-input>
                        </el-descriptions-item>
                        <el-descriptions-item span="4" label="操作">
                          <el-button type="primary" size="small" @click="addDrug()">新增用药</el-button>
                          <el-button type="primary" size="small" @click="deleteDrug(index)">删除</el-button>
                        </el-descriptions-item>
                      </el-descriptions>
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>

                <el-descriptions-item span="4" label="用药调整指导">
                  <el-descriptions :column="1" border>
                    <el-descriptions-item class="medicines" label="用药"
                      v-for="(item, index) in detail.content.medicinesGuide" :key="index">
                      <el-descriptions :column="4" border>
                        <el-descriptions-item span="2" label="药物名称">
                          <el-autocomplete class="inline-input" v-model="item.medicineName" :fetch-suggestions="querySearchAsync"
                          placeholder="请输入内容" :trigger-on-focus="false"></el-autocomplete>
                        </el-descriptions-item>
                        <el-descriptions-item span="2" label="用药次数/日">
                          <el-input v-model="item.freq"></el-input>
                        </el-descriptions-item>
                        <el-descriptions-item span="2" label="用量/次">
                          <el-input v-model="item.dosage"></el-input>
                        </el-descriptions-item>
                        <el-descriptions-item span="2" label="用药时间">
                          <el-input v-model="item.takeMethod"></el-input>
                        </el-descriptions-item>
                        <el-descriptions-item span="4" label="注意事项">
                          <el-input type="textarea" v-model="item.remark"></el-input>
                        </el-descriptions-item>
                        <el-descriptions-item span="4" label="操作">
                          <el-button type="primary" size="small" @click="addDrugGuide()">新增用药</el-button>
                          <el-button type="primary" size="small" @click="deleteDrugGuide(index)">删除</el-button>
                        </el-descriptions-item>
                      </el-descriptions>
                    </el-descriptions-item>
                  </el-descriptions>
                </el-descriptions-item>
              </el-descriptions>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="*随访人">
              <el-input v-model="detail.content.doctorName" placeholder="请输入内容"></el-input>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="*本次随访时间">
              <el-input disabled v-model="detail.content.followupTime" placeholder="请输入内容"></el-input>
            </el-descriptions-item>

            <el-descriptions-item span="4" label="*下次随访时间">
              <el-date-picker style="width: 200px" v-model="detail.content.nextFollowupTime" type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-descriptions-item>
          </el-descriptions>
        </ul>
      </el-container>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="showDialog = false">关闭</el-button>
        <el-button type="primary" size="small" @click="submit()">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { commitFollowUp, getMedicineList } from "@/api/health/Patients";
import pinyinMatch from "pinyin-match";

Date.prototype.Format = function (fmt) {
  //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};
export default {
  components: {},
  data() {
    return {
      symptomList: ["多饮", "多食", "多尿", "视力模糊", "感染", "手脚麻木", "下肢浮肿", "体重明显下降", "关节疼痛"],
      showDialog: false,
      title: "新建随访",
      restaurants: [],
      timeout: null,
      listLoading: false,
      symptomRadio: "2",
      medicationBadEventRadio: "2",
      symptomVisiable: false,
      medicationBadEventVisiable: false,
      sportTypeSelectDisable:false,
      detail: {
        serviceName: "",
        content: {
          bmi: null,
          drinkUnit: "两/天",
          symptoms: [],
          medicines: [
            {
              medicineName: "",
              freq: "",
              dosage: "",
              remark: "",
              takeMethod: ''
            }
          ],
          medicinesGuide: [
            {
              medicineName: "",
              freq: "",
              dosage: "",
              remark: "",
              takeMethod: ""
            }
          ],
          emptyGlu: "",
          twohourGlu: "",
          randomGlu: "",
          smokePerday: "0",
          smokePerdayTarget: "0",
          drinkPerday: "0",
          nextFollowupTime: "",
          dorsalisPedisPulse: "触及正常",
          drinkType: "啤酒",
          drinkPerdayTarget: '0',
          sportTired: "否",
          sportFall: "否",
          sportBloodsugar: "否",
          sportFoot: "否",
          medicationAdherence: "规律",
          allergy: "无",
          hypoglycemiaReaction: "无",
          knowDietSugar: "是",
          obeyDiabetesDiet: "是",
          dietRegular: "是",
          taste: "荤",
          dietHobbies: "基本均衡",
          followupTime: ""
        },
      },
      medicationAdherenceOptions: [
        {
          value: "规律",
          lebel: "规律"
        },
        {
          value: "间断",
          lebel: "间断"
        },
        {
          value: "服药",
          lebel: "服药"
        },
        {
          value: "不服药",
          lebel: "不服药"
        },
      ],
      hypoglycemiaReactionOptions: [
        {
          value: "无",
          label: "无"
        },
        {
          value: "偶尔",
          label: "偶尔",
        },
        {
          value: "频繁",
          label: "频繁"
        }

      ],
      dorsalisPedisPulseOptions: [
        {
          value: "触及正常",
          label: "触及正常"
        },
        {
          value: "减弱(双侧 左侧 右侧)",
          label: "减弱(双侧 左侧 右侧)"
        },
        {
          value: "消失(双侧 左侧 右侧)",
          label: "消失(双侧 左侧 右侧)"
        }
      ],
      drinkTypeList: [
        { label: "红酒", value: "红酒" },
        { label: "白酒", value: "白酒" },
        { label: "啤酒", value: "啤酒" },
      ],
      drinkUnitList: [
        { label: "两/天", value: "两/天" },
        { label: "瓶/天", value: "瓶/天" },
      ],
      dosageList: [
        { label: "上午", value: "上午" },
        { label: "下午", value: "下午" },
        { label: "晚上", value: "晚上" },
      ],
      sportTypeList: [
        {label: '无', value: '无'},
        {label: '慢走', value: '慢走'},
        {label: '快走', value: '快走'},
        {label: '慢跑', value: '慢跑'},
        {label: '游泳', value: '游泳'},
        {label: '跳绳', value: '跳绳'},   
        {label: '太极拳', value: '太极拳'},   
      ],
      sportMinutesEachList: [
        { label: "10分钟", value: "10分钟" },
        { label: "10-20分钟", value: "10-20分钟" },
        { label: "20-30分钟", value: "20-30分钟" },
        { label: "大于30分钟", value: "大于30分钟" }
      ],
      sportFreqList: [
        { label: "一次", value: "一次" },
        { label: "两次", value: "两次" },
        { label: "三次", value: "三次" },
        { label: "三次以上", value: "三次以上" },
      ],
      sportTiredList: [
        { label: "是", value: "是" },
        { label: "否", value: "否" },
      ],
      tasteList: [
        { label: "荤", value: "荤" },
        { label: "素", value: "素" },
        { label: "咸", value: "咸" },
        { label: "甜", value: "甜" },
      ],
      dietHobbiesList: [
        { label: "基本均衡", value: "基本均衡" },
        { label: "主食为主", value: "主食为主" },
        { label: "肉食为主", value: "肉食为主" },
        { label: "素食为主", value: "素食为主" },
        { label: "水产品为主", value: "水产品为主" },
      ],
      // sportTypeList: [
      //   { label: "只做有氧运动", value: "只做有氧运动" },
      //   { label: "只做抗阻运动", value: "只做抗阻运动" },
      //   { label: "两者都做", value: "两者都做" }
      // ]
      serviceName:''
    };
  },
  created() {
  },
  watch: {
    medicationBadEventRadio: {
      handler(newval) {
        if (newval == 2) {
          this.medicationBadEventVisiable = true;
        } else {
          this.medicationBadEventVisiable = false;
        }
      },
      immediate: true,
      deep: true
    },
    symptomRadio: {
      handler(newval) {
        if (newval == 2) {
          this.detail.content.symptoms = [];
          this.symptomVisiable = true;
        } else {
          this.detail.content.symptoms = [];
          this.symptomVisiable = false;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    async querySearchAsync(queryString, cb) {
      await this.loadAll(queryString);
      var restaurants = this.restaurants;
      var results = restaurants.filter((item) => {
        const name = item.value.toLowerCase();
        const match = pinyinMatch.match(name, queryString) || name.includes(queryString);
        return match;
      });

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 3000 * Math.random());
    },
    createStateFilter(queryString) {
      return (state) => {
        return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    loadAll(value) {
      var params = {name: value}
      getMedicineList(params).then((res) => {
        if (res.msg == "success") {
          res.data.records.forEach((item) => {
            this.restaurants.push({
              value: item.name,
              address: item.name
            })
          })
        }
      }).catch((error) => {
        console.log(error);
      })
    },
    sportTypeSelectChange(e){
      console.log(e);
      if (e == "无") {
        this.sportTypeSelectDisable = true;
      }else{
        this.sportTypeSelectDisable = false;
      }
    },
    // 编辑初始化页面内容
    async init(dataContext) {
      console.log("新建随访：",dataContext);

      this.detail.serviceName = dataContext.serviceName;
      this.serviceName = dataContext.serviceName;

      if (dataContext.hasOwnProperty("records")) {
        if (dataContext.records.content) {
          this.detail.content = dataContext.records.content;
        }
      }
      this.detail.content.bloodsugarTime = dataContext.bloodsugarTime;
      this.detail.idcard = dataContext.idcard;
      this.detail.phone = dataContext.phone;
      this.detail.contactName = dataContext.contactName;
      this.detail.contactPhone = dataContext.contactPhone;
      this.detail.healthNo = dataContext.healthNo ? dataContext.healthNo.substr(dataContext.healthNo.length - 8) : "--";
      this.detail.patientName = dataContext.patientName;
      this.detail.address = dataContext.village;
      this.detail.content.nextFollowupTime = dataContext.nextFollowupTime;
      // this.detail.content.emptyGlu = dataContext.bloodSuger[0]?.value ? dataContext.bloodSuger[0].value : "--";
      // this.detail.content.twohourGlu = dataContext.bloodSuger[1]?.value ? dataContext.bloodSuger[1].value : "--";
      // this.detail.content.randomGlu = dataContext.bloodSuger[2]?.value ? dataContext.bloodSuger[2].value : "--";
      this.detail.content.doctorName = this.$store.getters.name;
      this.getSystemTime();
      this.showDialog = true;
    },
    // 关闭对话框触发
    setDialogClosed() {
      this.sportTypeSelectDisable = false;
      this.detail = {
        serviceName: this.serviceName,
        content: {
          drinkUnit: "两/天",
          symptoms: [],
          medicines: [
            {
              medicineName: "",
              freq: "",
              dosage: "",
              remark: "",
              takeMethod: ""
            }
          ],
          medicinesGuide: [
            {
              medicineName: "",
              freq: "",
              dosage: "",
              remark: "",
              takeMethod: ""
            }
          ],
          emptyGlu: "",
          twohourGlu: "",
          randomGlu: "",
          height: "",
          sbp: "",
          dbp: "",
          tg: "",
          weight: "",
          bmi: null,
          tc: "",
          waist: "",
          hdlc: "",
          ldlc: "",
          smokePerday: "0",
          smokePerdayTarget: '0',
          drinkPerday: '0',
          nextFollowupTime: "",
          dorsalisPedisPulse: "触及正常",
          drinkType: "啤酒",
          drinkPerdayTarget: '0',
          sportFreq: "",
          sportMinutesPertime: "",
          sportTired: "否",
          sportFall: "否",
          sportBloodsugar: "否",
          sportFoot: "否",
          sportType:"",
          sportPeriodGuides: "",
          sportMinutesPertimeTarget: "",
          sportFreqTarget: "",
          medicationAdherence: "规律",
          allergy: "无",
          hypoglycemiaReaction: "无",
          knowDietSugar: "是",
          obeyDiabetesDiet: "是",
          dietRegular: "是",
          taste: "荤",
          dietHobbies: "基本均衡",
          dietGuide: "",
          followupTime: ""
        },
      },
      this.showDialog = false;
    },
    addDrug() {
      var drugItem = {
        medicineName: "",
        freq: "",
        dosage: "",
        remark: "",
        takeMethod: ""
      };
      this.detail.content.medicines.push(drugItem);
    },
    deleteDrug(index) {
      this.detail.content.medicines.splice(index, 1);
    },
    addDrugGuide() {
      var drugItem = {
        medicineName: "",
        freq: "",
        dosage: "",
        remark: "",
        takeMethod: ""
      };
      this.detail.content.medicinesGuide.push(drugItem);
    },
    deleteDrugGuide(index) {
      this.detail.content.medicinesGuide.splice(index, 1);
    },
    submit() {
      if (!this.detail.content.height) {
        this.$message({
          message: "请输入身高！",
          type: "error"
        })
        return;
      };

      if (!this.detail.content.sbp) {
        this.$message({
          message: "请输入收缩压！",
          type: "error"
        })
        return;
      };

      if (!this.detail.content.dbp) {
        this.$message({
          message: "请输入舒张压！",
          type: "error"
        })
        return;
      };

      if (!this.detail.content.weight) {
        this.$message({
          message: "请输入体重！",
          type: "error"
        })
        return;
      };

      if (!this.detail.content.waist) {
        this.$message({
          message: "请输入腰围！",
          type: "error"
        })
        return;
      };

      if (!this.detail.content.smokePerday) {
        this.$message({
          message: "请输入生活方式指导中日吸烟量！",
          type: "error"
        })
        return;
      };

      if (!this.detail.content.smokePerdayTarget) {
        this.$message({
          message: "请输入生活方式指导中日吸烟量指导！",
          type: "error"
        })
        return;
      };

      if (!this.detail.content.drinkPerday) {
        this.$message({
          message: "请输入生活方式中日饮酒量！",
          type: "error"
        })
        return;
      };

      if (!this.detail.content.drinkPerdayTarget) {
        this.$message({
          message: "请输入生活方式日饮酒量指导中饮酒量！",
          type: "error"
        })
        return;
      };

      if (!this.detail.content.sportFreq) {
        this.$message({
          message: "请输入运动基本情况中运动频次！",
          type: "error"
        })
        return;
      };

      if (!this.detail.content.sportMinutesPertime) {
        this.$message({
          message: "请输入运动基本情况中运动时长！",
          type: "error"
        })
        return;
      };

      if (!this.detail.content.sportType) {
        this.$message({
          message: "请选择运动行为指导中运动形式！",
          type: "error"
        })
        return;
      };

      if (this.sportTypeSelectDisable == false) {
        if (!this.detail.content.sportPeriodGuides) {
        this.$message({
          message: "请选择运动行为指导中运动时间！",
          type: "error"
        })
        return;
      };

      if (!this.detail.content.sportMinutesPertimeTarget) {
        this.$message({
          message: "请选择运动行为指导中运动时长！",
          type: "error"
        })
        return;
      };

      if (!this.detail.content.sportFreqTarget) {
        this.$message({
          message: "请选择运动行为指导中运动频次！",
          type: "error"
        })
        return;
      };
      }

      if (!this.detail.content.dietGuide) {
        this.$message({
          message: "请输入饮食指导！",
          type: "error"
        })
        return;
      };

      this.detail.content.bmi = Number(this.detail.content.weight / (Math.pow(this.detail.content.height / 100, 2))).toFixed(2);

      let params = this.detail;
      console.log("======参数=====", this.detail)
      commitFollowUp(params).then(res => {
        if (res.msg == "success") {
          this.$message({
            message: "新建随访成功！",
            type: "success",
          });
          this.showDialog = false;
        } else if (res.code == "500") {
          this.$message({
            message: res.msg,
            type: "error",
          });
        } else {
          this.$message({
            message: "新建随访失败！",
            type: "error",
          });
        }
      }).catch((error) => {
        console.log(error);
      })
    },
    // 获取系统时间
    getSystemTime() {
      // 实例化日期类
      var time = new Date();
      // 获取完整的年份(4位)
      var year = time.getFullYear();
      // 获取月份(0-11,0代表1月)
      var month = time.getMonth();
      // 获取日期(1-31)
      var date = time.getDate();
      var hour = time.getHours();
      var minute = time.getMinutes();
      var second = time.getSeconds();
      //测试打印
      console.log(year + "年" + month + "月" + date + "日 ");
      time.setFullYear(year, month, date);
      time.setHours(hour, minute, second);

      this.detail.content.followupTime = time.Format("yyyy-MM-dd hh:mm:ss"); //yyyy-MM-dd'T'HH:mm:ss.SSSZ
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  height: 500px !important;
  overflow: auto !important;
}

::v-deep {
  .el-dialog {
    margin-top: 5vh !important;
  }

  .el-descriptions-item__label.is-bordered-label {
    width: 100px;
  }

  .el-checkbox-group {
    width: 100px;
  }
}
</style>